import styled from "styled-components/macro";

const Root = styled.div`
  box-sizing: border-box;
  padding: 60px 0px;
  margin: 0 auto;
  min-height: 2000px;
  max-width: 1400px;
  width: 75%;

  @media (max-width: 1024px) {
    padding: 0 111px;
  }

  @media (max-width: 577px) {
    padding: 0 20px;
    width: 100%;
  }
`;

const Wrapper = ({ children }) => {
  return <Root>{children}</Root>;
};

export default Wrapper;
